
module.exports = window.$;



/** WEBPACK FOOTER **
 ** /Users/mitch/jsapps/modules/jquery.js
 **/